import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { GlobalVariable } from '../Variable/global-variable';
import { catchError, map } from 'rxjs/operators';
import { AppTokenHandler } from 'src/app/Global-Services/app-token-handler';
import { Location } from '@angular/common';
import { FTEDetailsDataViewRequest } from 'src/app/Models/request-objects.model';

const APIEndpoint = environment.apiPath;

@Injectable()

export class CommonService {
  private User: any = null;
  private httpHeaderFileDownload: any;
  private httpDataServiceOptions: any;
  private httpHeaderFileUpload: any;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private gVariable: GlobalVariable, private appToken: AppTokenHandler, private _location: Location) {

    this.httpHeaderFileDownload = {
      withCredentials: true,
      responseType: 'blob'
    };

    this.httpHeaderFileUpload = {
      headers: new HttpHeaders({
        'AUTHA': this.appToken.getSessionToken()
      }),
      withCredentials: true
    };

  }

  RedirectToErrorPage(Id: any) {
    sessionStorage.removeItem('userToken');
    sessionStorage.removeItem('userDetails');
    this.router.navigate(['/error', Id]);
  }
  NullCheck(value: any) {
    if (value == null || value == undefined || value == "" || value == 0 || Number.isNaN(value)) {
      return true;
    }
    else {
      return false;
    }
  }
  ExportExcelDataForEmployees(list: any): Observable<any> {
    const url: string = environment.apiPath + 'FTERecords/ExportToExcel';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, list, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }
    userAuthentication(href: string, type: string) {
        this.httpDataServiceOptions = {
            headers: new HttpHeaders({
                'AzureAccessToken': this.appToken.getAzureTokenFromLocalStorage(),
                'Content-Type': 'application/json'
            })
        };
        this.http.get(environment.tokenPath + 'Login/UserDetailAndToken', this.httpDataServiceOptions).subscribe((data: any) => {
            if (data != null) {
                sessionStorage.setItem('userToken', data.TokenID);
                sessionStorage.setItem('userDetails', JSON.stringify(data));
                this.gVariable.userToken = data.TokenID;
                this.gVariable.User = this.getUserDetails(type);
                if (href === '') {
                    href = this._location.path();
                }
                if (href === null || href === undefined || href === '') {
                    this.router.navigate(['/INFTE/home']);
                } else {
                    this.router.navigate([href]);
                }
            } else {
                this.RedirectToErrorPage('1');
            }
        },
            (err: HttpErrorResponse) => {

                this.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
                });

                this.router.navigate(['/unAuthorize']);
            });
    }

  getUserDetails(type) {
    this.User = JSON.parse(sessionStorage.getItem('userDetails'));
    if (this.User == null) {
      if (type == 'first') {
        this.userAuthentication('/INFTE/home', type);
      }
      else
        this.router.navigate(['/logout']);
    } else {
      return this.User;
    }
  }

  GetUser(Url: string): Observable<any> {
    const reqHeader = new HttpHeaders({
      'NO-Auth': 'True'
    });
    return this.http.get<any>(environment.apiPath + Url, { headers: reqHeader, withCredentials: true }).pipe
      ((res: any) => {
        return res;
      }
      );
  }

  GetFTEDetailsDataView(CurrUserGPN: any, ParamID: any, Parameter: any, IsExport: any, IsAdmin: any): Observable<any> {
    const url: string = environment.apiPath + 'ViewFTERecords/GetFTEDetailsDataView';
    let fteDetailsDataViewRequest: FTEDetailsDataViewRequest = new FTEDetailsDataViewRequest({
      CurrUserGPN: CurrUserGPN,
      ParamID: ParamID,
      CreatedOnFrom: Parameter.CreatedOnFrom,
      CreatedOnTo: Parameter.CreatedOnTo,
      CouncelorActionOnFrom: Parameter.CouncelorActionOnFrom,
      CouncelorActionOnTo: Parameter.CouncelorActionOnTo,
      PartnerActionOnFrom: Parameter.PartnerActionOnFrom,
      PartnerActionOnTo: Parameter.PartnerActionOnTo,
      LastIncrementDateFrom: Parameter.LastIncrementDateFrom,
      LastIncrementDateTo: Parameter.LastIncrementDateTo,
      EmpContractEndDateFrom: Parameter.EmpContractEndDateFrom,
      EmpContractEndDateTo: Parameter.EmpContractEndDateTo,
      FTEID: Parameter.FTEID,
      EmpLocationText: Parameter.EmpLocationText,
      EmpName: Parameter.EmpName,
      EmpEmail: Parameter.EmpEmail,
      ServiceLineText: Parameter.ServiceLineText,
      CouncelorName: Parameter.CouncelorName,
      EmpTitle: Parameter.EmpTitle,
      ManagerName: Parameter.ManagerName,
      PartnerName: Parameter.PartnerName,
      PageNumber: Parameter.currentPage,
      IDList: Parameter.IDList,
      IsExport: IsExport,
      IsAdmin: IsAdmin,
      RequestStatusID: Parameter.RequestStatusID,
      EmpGPN: Parameter.EmpGPN
    });
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, fteDetailsDataViewRequest, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetFTEDetailsByID(ID: any, CurrUserGPN: any): Observable<any> {
    const requestInput = { Parameter1: ID, Parameter2: CurrUserGPN };
    const url: string = environment.apiPath + 'FTEDetails/GetFTEDetailsByID';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }


  GetAccessRecordDataByID(ID: any, CurrUserGPN: any): Observable<any> {
    const requestInput = { Parameter1: ID, Parameter2: CurrUserGPN };
    const url: string = environment.apiPath + 'AccessMatrix/GetAccessRecordDataByID';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetFinanceUserMappingRecordDataByID(ID: any, CurrUserGPN: any): Observable<any> {
    const requestInput = { Parameter1: ID, Parameter2: CurrUserGPN };
    const url: string = environment.apiPath + 'AccessMatrix/GetFinanceUserMappingRecordDataByID';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetKeyWordByKeyWordType(KeyWordType: any, EmpGPN: string = ''): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetKeyWordByKeyWordType';
    const requestInput = { Parameter1: KeyWordType, Parameter2: EmpGPN };
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetLocation(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetLocation';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }

  GetMarketSegmentForDropDown(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetMarketSegmentForDropDown';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
    );
  }

  GetCompetencyForDropDown(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetCompetencyForDropDown';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
    );
  }

  GetServiceLine(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetServiceLine';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }

  GetTitle(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetTitle';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }

  GetEmpSearch(LikeName: string, UserGPN: string) {
    LikeName = LikeName.replace(/ /g, '-');
    const requestInput = { Parameter1: LikeName, Parameter2: UserGPN };
    const url: string = environment.apiPath + 'Master/GetEmpSearch';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetEmployeeSearch(LikeName: string, UserGPN: string) {
    LikeName = LikeName.replace(/ /g, '-');
    const requestInput = { Parameter1: LikeName, Parameter2: UserGPN };
    const url: string = environment.apiPath + 'Master/GetEmployeeSearch';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetManagerSearch(LikeName: string, UserGPN: string) {
    LikeName = LikeName.replace(/ /g, '-');
    const requestInput = { Parameter1: LikeName, Parameter2: UserGPN };
    const url: string = environment.apiPath + 'Master/GetManagerList';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetPartnerSearch(LikeName: string, UserGPN: string) {
    LikeName = LikeName.replace(/ /g, '-');
    const requestInput = { Parameter1: LikeName, Parameter2: UserGPN };
    const url: string = environment.apiPath + 'Master/GetPartnerList';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GetEngagementSearch(LikeName: string, UserGPN: string) {
    const requestInput = { Parameter1: LikeName, Parameter2: UserGPN };
    const url: string = environment.apiPath + 'Master/GetEngagementSearch';
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  GenerateLetter(objFTERecord: any[]) {
    return this.http.get<any>(environment.apiPath + 'ReportExport/GenerateLetter/' + objFTERecord,
      { withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }

  UpdateCouncelorAction(apiUrl: string) {
    //
    return this.http
      .post(APIEndpoint + apiUrl, this.httpDataServiceOptions)
      .pipe(map(data => data));
  }

  UpdatePartnerAction(apiUrl: string) {
    return this.http
      .post(APIEndpoint + apiUrl, this.httpDataServiceOptions)
      .pipe(map(data => data));
  }

  Logout() {
    //
    return this.http.get<any>(environment.tokenPath + 'Login/LogOutUser', { withCredentials: true }).
      pipe(
    );
    //   this.router.navigate(['/error/logout'], { relativeTo: this.route });
  }
  Login() {
    this.router.navigate(['/login']);
  }
  HomePage() {
    this.router.navigate(['/login']);
    // this.router.navigate(['/INFTE/home']);
  }
  Exit() {
    this.router.navigate(['/INFTE/home']);
  }

  PostService(param: any, apiUrl: string): any {
    return this.http.post(APIEndpoint + apiUrl, param, this.httpDataServiceOptions)
      .pipe(map(data => data));
  }

  GetRestItems(apiUrl: string) {
    return this.http.get(APIEndpoint + apiUrl, this.httpDataServiceOptions)
      .pipe(map(data => data));
  }

  Download(apiUrl: string) {
    return this.http.get(APIEndpoint + apiUrl, this.httpHeaderFileDownload)
      .pipe(map(data => data));
  }
  PostDownload(Url: string, param: any) {
    return this.http.post(APIEndpoint + Url, param, this.httpHeaderFileDownload)
      .pipe();
  }
  GetAllAuditTrailByID(Id: number, ClassName: string): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetAllAuditTrailByID';
    const requestInput = { Parameter6: Id, Parameter1: ClassName };
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, requestInput, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  UploadAttachment(param, apiUrl: string) {
    return this.http.post<any>(APIEndpoint + apiUrl, param, { withCredentials: true })
      .pipe(map(data => data));
  }

  GetDashboardKeyContactData(): Observable<any> {
    const url: string = environment.apiPath + 'Master/GetDashboardKeyContactData';
    const httpLoginPostOptions = {
      withCredentials: true,
    };
    return this.http.get<any>(url, httpLoginPostOptions).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }
  //added by vedha bethi on 15-jun-2021 for CR_2103_0066
  CheckUserIsFinanceTeam(userGPN: string): Observable<any> {
    const url: string = environment.apiPath + 'FTEDetails/CheckUserIsFinanceTeam';
    let params = new HttpParams();
    params = params.append('userGPN', userGPN);
    const httpLoginPostOptions = {
      withCredentials: true,
      params: params
    };
    return this.http.post<any>(url, params, { withCredentials: true })
      .pipe(map(data => data));
  }


  DownloadFTEUploadFormat(CurrUserGPN: any, ParamID: any, Parameter: any, IsExport: any, IsAdmin: any): Observable<any> {
    //
    const url: string = environment.apiPath + 'ViewFTERecords/DownloadFTEUploadFormat';
    let fteDetailsDataViewRequest: FTEDetailsDataViewRequest = new FTEDetailsDataViewRequest({
      CurrUserGPN: CurrUserGPN,
      ParamID: ParamID,
      CreatedOnFrom: Parameter.CreatedOnFrom,
      CreatedOnTo: Parameter.CreatedOnTo,
      CouncelorActionOnFrom: Parameter.CouncelorActionOnFrom,
      CouncelorActionOnTo: Parameter.CouncelorActionOnTo,
      PartnerActionOnFrom: Parameter.PartnerActionOnFrom,
      PartnerActionOnTo: Parameter.PartnerActionOnTo,
      LastIncrementDateFrom: Parameter.LastIncrementDateFrom,
      LastIncrementDateTo: Parameter.LastIncrementDateTo,
      EmpContractEndDateFrom: Parameter.EmpContractEndDateFrom,
      EmpContractEndDateTo: Parameter.EmpContractEndDateTo,
      FTEID: Parameter.FTEID,
      EmpLocationText: Parameter.EmpLocationText,
      EmpName: Parameter.EmpName,
      EmpEmail: Parameter.EmpEmail,
      ServiceLineText: Parameter.ServiceLineText,
      CouncelorName: Parameter.CouncelorName,
      EmpTitle: Parameter.EmpTitle,
      ManagerName: Parameter.ManagerName,
      PartnerName: Parameter.PartnerName,
      PageNumber: Parameter.currentPage,
      IDList: Parameter.IDList,
      IsExport: IsExport,
      IsAdmin: IsAdmin,
      RequestStatusID: Parameter.RequestStatusID,
      EmpGPN: Parameter.EmpGPN
    });
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, fteDetailsDataViewRequest, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }
  //end by vedha bethi on 15-jun-2021 for CR_2103_0066
  // Added by Samikchha Kumar on 25/04/2023

  employeeDetailFromHrData(CurrUserGPN: any, ParamID: any, Parameter: any, IsExport: any, IsAdmin: any): Observable<any> {
    const url: string = environment.apiPath + 'FTERecords/employeeDetailFromHrData';
    const param = {
    'CurrUserGPN': CurrUserGPN,
    'ParamID': ParamID,
    'IsExport': IsExport,
    'IsAdmin': IsAdmin,
    'PageNumber': Parameter.currentPage,
    'EmpGPN': Parameter.EmpGPN,
    'EmpLPN': Parameter.EmpLPN,
    'EmpName': Parameter.EmpName,
    'ServiceLineID': Parameter.ServiceLineID,
    'ServiceLineText': Parameter.ServiceLineText,
    'EmpTitle': Parameter.EmpTitle,
    'EmpLocationID': Parameter.EmpLocationID,
    'EmpLocationText': Parameter.EmpLocationText,
    'EmpDOJ': Parameter.EmpDOJ,
    'EmpManagerGPN': Parameter.EmpManagerGPN,
    'EmpManagerName': Parameter.EmpManagerName,
    'EmpPartnerName': Parameter.EmpPartnerName,
    'EmpFirm': Parameter.EmpFirm,
    'UpdatedEngagementCode': Parameter.UpdatedEngagementCode,
    'EngClientName': Parameter.EngClientName,
    }

    if (ParamID == '5') {
      param['FromDate'] = Parameter.FromDate;
      param['ToDate'] = Parameter.ToDate;
    }

    if (IsExport) {
      param['EngCodeUpdatedOn'] = Parameter.EngCodeUpdatedOn;

    }


    return this.http.post<any>(url, param, {withCredentials: true}).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }

  GetEngCodeHistory(ID: any, CurrUserGPN: any, PageNumber: any, Parameter: any, IsAdmin: any): Observable<any> {
    const url: string = environment.apiPath + 'FTERecords/GetEngCodeHistory';
    const param = {
      'ID': ID,
      'CurrUserGPN': CurrUserGPN,
      'PageNumber': PageNumber,
    'IsAdmin': IsAdmin,
    'EngCode': Parameter.EngCode,
    'EngTitle': Parameter.EngTitle,
    'CostAllocation': Parameter.CostAllocation,
   'EngPartner': Parameter.EngPartner,
    'EngManager': Parameter.EngManager,
    'UpdatedBy': Parameter.UpdatedBy,
    'UpdatedOn': Parameter.UpdatedOn,
    }

    return this.http.post<any>(url, param, {withCredentials: true}).
      pipe(map(data => data));
  }


  GetFTERecordsByID(ID: any, CurrUserGPN: any): Observable<any> {
    const url: string = environment.apiPath + 'FTERecords/GetFTERecordsByID';
    const param = {
      'ID': ID,
      'CurrUserGPN': CurrUserGPN,
    }

    return this.http.post<any>(url, param, {withCredentials: true}).
      pipe(
      // catchError(this.handleError('addHero', hero))
    );
  }
  GetEngCodeSearch(LikeName: any, UserGPN: any) {
    LikeName = LikeName.trim();
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    return this.http.post<any>(environment.apiPath + '/GetEngCodeSearch', param,{ withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }


  GetEmpCodeSearch(LikeName: any, UserGPN: any) {
    LikeName = LikeName.replace(/ /g, '-');
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    return this.http.post<any>(environment.apiPath + '/GetEmpCodeSearch' , param, { withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }
  //Added by Samikchha
  GetEngagementCodeSearch(LikeName: any, UserGPN: any) {
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    LikeName = LikeName.replace(/ /g, '-');
    return this.http.post<any>(environment.apiPath + '/GetEngagementCodeSearch/' , param,{ withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }

  GetClientNameSearch(LikeName: any, UserGPN: any) {
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    LikeName = LikeName.replace(/ /g, '-');
    return this.http.post<any>(environment.apiPath + '/GetClientNameSearch/' , param,{ withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }
  //End by Samikchha
  GetEmpNameSearch(LikeName: any, UserGPN: any) {
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    LikeName = LikeName.replace(/ /g, '-');
    return this.http.post<any>(environment.apiPath + '/GetEmpNameSearch'  , param,{ withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }
  GetRepManagerSearch(LikeName: any, UserGPN: any) {
    const param = {
      'LikeName': LikeName,
      'UserGPN': UserGPN,
    }
    LikeName = LikeName.replace(/ /g, '-');
    return this.http.post<any>(environment.apiPath + '/GetRepManagerSearch/' , param,{ withCredentials: true }).
      pipe((res: any) => {
        return res;
      }
      );
  }
  // END by Samikchha Kumar on 25/04/2023


  DownloadAccessMatrixUploadFormat(templateName: any): Observable<any> {
    const url: string = environment.apiPath + 'AccessMatrix/DownloadAccessMatrixUploadFormat';
    const param = {
      'TemplateName': templateName,
    }
    const httpLoginPostOptions = {
      withCredentials: true
    };
    return this.http.post<any>(url, param, httpLoginPostOptions).pipe(
      map((response: any) => response),
      catchError((error) => {
        return throwError(() => error.message);
      })
    );
  }

  PostDataWithParam(Url: string, param: any,) {
    return this.http.post<any>(APIEndpoint + Url , param, { withCredentials: true })
      .pipe(map(data => data));
  }
}

